import { cancelOnSessionChange } from '../session-cancellation';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationsService } from '@api/services/organizations.service';
import * as OrganizationsActions from '../../actions/organizations/projects.actions';

@Injectable()
export class OrganizationsProjectsEffects {
  loadProjects$;
  loadProjectById$;
  createProject$;
  updateProject$;
  deleteProject$;

  constructor(
    private actions$: Actions,
    private organizationsService: OrganizationsService,
  ) {

        this.loadProjects$ = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganizationsActions.loadProjects),
            mergeMap(({ organizationId }) =>
              this.organizationsService.organizationsGetProjects({ organizationId }).pipe(
                map((projects) =>
                  OrganizationsActions.loadProjectsSuccess({
                    projects: projects.map((p) => ({ data: p, loadedAt: new Date() }))
                  })
                ),
                catchError((error) => of(OrganizationsActions.loadProjectsFailure({ error }))),
            cancelOnSessionChange(this.actions$)
              )
            )
          )
        );
    
        this.loadProjectById$ = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganizationsActions.loadProjectById),
            mergeMap(({ organizationId, projectId }) =>
              this.organizationsService.organizationsGetProjectById({ organizationId, projectId }).pipe(
                map((project) =>
                  OrganizationsActions.loadProjectByIdSuccess({
                    project: { data: project, loadedAt: new Date() }
                  })
                ),
                catchError((error) => of(OrganizationsActions.loadProjectByIdFailure({ error }))),
            cancelOnSessionChange(this.actions$)
              )
            )
          )
        );
    
        this.createProject$ = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganizationsActions.createProject),
            mergeMap(({ organizationId, project }) =>
              this.organizationsService.organizationsCreateProject({
                organizationId,
                body: project.data
              }).pipe(
                map((response) =>
                  OrganizationsActions.createProjectSuccess({
                    project: { data: response.project!, loadedAt: new Date() },
                    organization: { data: response.organization!, loadedAt: new Date() }
                  })
                ),
                catchError((error) => of(OrganizationsActions.createProjectFailure({ error }))),
            cancelOnSessionChange(this.actions$)
              )
            )
          )
        );
    
        this.updateProject$ = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganizationsActions.updateProject),
            mergeMap(({ organizationId, projectId, project }) =>
              this.organizationsService.organizationsUpdateProjectById({
                organizationId,
                projectId: projectId,
                body: project.data
              }).pipe(
                map((updatedProject) =>
                  OrganizationsActions.updateProjectSuccess({
                    project: { data: updatedProject, loadedAt: new Date() }
                  })
                ),
                catchError((error) => of(OrganizationsActions.updateProjectFailure({ error }))),
            cancelOnSessionChange(this.actions$)
              )
            )
          )
        );
    
        this.deleteProject$ = createEffect(() =>
          this.actions$.pipe(
            ofType(OrganizationsActions.deleteProject),
            switchMap(({ organizationId, projectId }) =>
              this.organizationsService.organizationsDeleteProjectById({ organizationId, projectId }).pipe(
                map(() => OrganizationsActions.deleteProjectSuccess({ projectId })),
                catchError((error) => of(OrganizationsActions.deleteProjectFailure({ error }))),
            cancelOnSessionChange(this.actions$)
              )
            )
          )
        );
  }
}